export default "__VITE_ASSET__CnxlUEap__"